import { DataService } from "./data.service";
import { AxiosRequestConfig } from "axios";

export class ApiService extends DataService {

  // eslint-disable-next-line
  getData(url: string, params?: string): Promise<any> {
    return this.instance({
      method: "GET",
      url: url,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  // eslint-disable-next-line
  postData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "POST",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  // eslint-disable-next-line
  putData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "PUT",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }

  // eslint-disable-next-line
  deleteData(url: string, data?: any, params?: string): Promise<any> {
    return this.instance({
      method: "DELETE",
      url: url,
      data: data,
      params: params,
    }).then((response) => {
      return response;
    }).catch((error) => {
      throw error;
    });
  }
}
